const crewJobs = {
	DIRECTOR: 'Director',
	SCREENPLAY: 'Screenplay'
}

export default Object.freeze(crewJobs)
